import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { GlobalContext, Section } from "../lib/Root";
import { useContext, useEffect, useState } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Box, Button, TextField } from '@mui/material';
import axios from "../lib/Axios";
import { z } from "zod";

//Define validation parameters required for each field.
var schema = z.object({
	email: z.string().email(),
	password: z.string().min(8)
});

export default function AccountLogin() {
	var _ = window._ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "Login"; }, []);

	//Get query string from URL.
	var [searchParams, setSearchParams] = useSearchParams();
	var [redirect, setRedirect] = useState(searchParams.get("redirect"));
	var [local] = useState(searchParams.has("local"));
    var [query] = useState("?" + searchParams);

	//If redirect is set, store it, then remove it.
	//Save all other queries to a string to pass along.
	var navigate = useNavigate();

	//Define hooks and handlers.
	var { register, handleSubmit, setError, formState: { errors, isSubmitting } } = useForm({ resolver: zodResolver(schema) });
	
	//Function that gets the form data when submitted.
	var onSubmit = async (data) => {
		return axios.post("/user/login", new URLSearchParams(data)).then(({ data }) => {
			if (data.state === true) {
				axios.get("/user").then(({ data }) => {
					//Update global context state with new user data.
					_.user = data;

					//Check if user has a "default" level permission of -1.
					//This indicates this is a new user with an unverified account.
					//Redirect new users to the OTC page to verify their account.
					if (data?.active === -1) { redirect = "/account/otc?new"; local = true; }
				}).then(() => {
					redirect ? (local ? navigate(redirect) : (window.location.href = redirect)) : navigate("/account");
				}).catch(() => { window.location.href = "/"; });
			} else {
				throw Error(data.description);
			}
		}).catch(e => {
			setError("root", { message: e.message });
		});
	};

	if (_.user.id > 0) {
		return <Section small center>
			<p>You are currently logged in as <b>{_.user.name}</b>.</p>
			<p><Button variant="contained" onClick={() => navigate("/account/logout" + query)}>Logout</Button></p>
		</Section>;
	}
	
	//Output actual form.
	return <Section small center>
		<Box component="form" onSubmit={handleSubmit(onSubmit)}>
			{errors.root && (<div className="notice">{errors.root.message}</div>)}
			<TextField {...register("email")} label="Email" autoComplete="on" error={!!errors.email} helperText={errors.email?.message} />
			<TextField {...register("password")} type="password" label="Password" autoComplete="on" error={!!errors.password} helperText={errors.password?.message} />
			<Button disabled={isSubmitting} type="submit">{isSubmitting ? "Logging In" : "Login"}</Button>
			<span style={{ display: "block" }}>Don't have an account? <Link to="/account/register">Sign Up!</Link></span>
		</Box>
	</Section>;
}